import React from 'react';

function MultipleChoiceQuestion({ options, answer, onAnswerChange, questionId }) {
  return (
    <div className="mb-6">
      <div className="flex flex-col gap-3">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => onAnswerChange(questionId, option)}
            className={`p-4 border-2 rounded-lg transition-all text-left ${
              answer === option
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-300 hover:border-gray-400'
            }`}
          >
            <span className="font-medium">{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MultipleChoiceQuestion;
